import React from "react";
import Button from "../../../components/common/button";
import { FileText, Download, Image as ImageIcon, Eye, Grid } from "react-feather";
import moment from "moment";
import { IReport } from "../../../interfaces/report";
import { Link } from "react-router-dom";

type ReportStatus = "complete" | "processsing" | "submitted";

interface IProps {
	report: IReport | any;
}

const ReportRow: React.FC<IProps> = ({ report }) => {
	const extension = report.report_uri?.split("?")[0].split(".").pop()?.toLowerCase();
	
	const getFileIcon = (ext: string) => {
		switch (ext) {
			case "pdf":
				return <FileText size={17} className="mr-2 text-danger" />;
			case "jpg":
			case "jpeg":
			case "png":
				return <ImageIcon size={17} className="mr-2 text-success" />;
			case "xlsx":
			case "xls":
			case "csv":
				return <Grid size={17} className="mr-2 text-primary" />;
			default:
				return <FileText size={17} className="mr-2 text-muted" />;
		}
	};

	// Mock file size if not available (based on length of description or random)
	const fileSize = report.file_size || `${(Math.random() * 5 + 1).toFixed(1)} MB`;

	return (
		<tr>
			<td className="company-column">{report.requested_by?.name || "Company Name"}</td>
			<td className="type-column">
				<div className="d-flex align-items-center">
					{getFileIcon(extension || "")}
					<div>
						<div className="text-dark font-weight-medium">{report.report_type || "Report Type"}</div>
						<div className="small text-muted">{fileSize} • {extension?.toUpperCase() || "FILE"}</div>
					</div>
				</div>
			</td>
			<td className="date-column">{moment(report.request_date).format("MMM DD YYYY")}</td>
			<td className="description-column">
				<div className="truncate-2-lines" title={report.description}>
					{report.description || "No description provided."}
				</div>
			</td>
			<td className="actions-column">
				<div className="action-buttons d-flex flex-row justify-content-center">
					{report.status === "UPLOADED" && (
						<>
							<Link to={`${report.report_uri}`} target="_blank" className="mr-2">
								<Button className="btn-preview bg-light border-0 text-dark">
									<Eye size={14} className="mr-1" />
									Preview
								</Button>
							</Link>
							<Link to={`${report.report_uri}`} target="_blank" download>
								<Button outline color="primary" className="btn-download">
									<Download size={14} className="mr-1" />
									Download
								</Button>
							</Link>
						</>
					)}
					{report.status !== "UPLOADED" && (
						<span className={`status-badge ${report.status.toLowerCase()}`}>
							{report.status}
						</span>
					)}
				</div>
			</td>
		</tr>
	);
};

export default ReportRow;
